<p class="button-bar">
    <button
        title="Select All"
        pButton
        pRipple
        text
        severity="secondary"
        type="button"
        (click)="selectedEmployees = items"
        label="Select All"
    ></button>
    <button
        title="Select None"
        pButton
        pRipple
        text
        severity="secondary"
        type="button"
        (click)="selectedEmployees = []"
        label="Select None"
        class="mx-3"
    ></button>
    <button
        title="Send Hours"
        icon="pi pi-send"
        pButton
        pRipple
        severity="primary"
        type="button"
        (click)="onSendHours(employeeTree.selection)"
        label="Send Hours"
    ></button>
</p>
<p>
    <p-tree
        [filter]="true"
        filterMode="strict"
        filterPlaceholder="Search for user"
        #employeeTree
        [value]="items"
        selectionMode="checkbox"
        [(selection)]="selectedEmployees"
        scrollHeight="flex"
    ></p-tree>
</p>

